import { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';

import { MaskedInputProps } from './types';

export const MaskedInput = forwardRef<HTMLInputElement, MaskedInputProps>(
  ({ name, mask, value, onChange, placeholder, ...props }, ref) => (
    <IMaskInput
      {...props}
      mask={mask}
      value={value}
      inputRef={ref}
      placeholder={placeholder}
      definitions={{
        '0': /\d/,
        a: /[a-zA-Z]/,
        '*': /[a-zA-Z0-9]/,
      }}
      onAccept={(val: string) =>
        onChange?.({
          target: { name, value: val },
        })
      }
    />
  )
);

MaskedInput.displayName = 'MaskedInput';
